import * as React from 'react'
import PageLayout from '@/components/ui/page-layout'
import SubscriptionForm from '@/features/subscriptions/components/SubscriptionForm'
import PlanForm from '@/features/plans/components/PlanForm'

export default function NewPlanPage() {
    const breadcrumbs = [
        { label: 'Plans', href: '/plans' },
        { label: 'New Plan', href: '/plans/new' },
    ]
    return (
        <PageLayout title='New Plan' subtitle='Create a new plan' breadcrumbs={breadcrumbs}>
            <div className='border border-gray-600 rounded-xl p-4 max-w-2xl'>
                <PlanForm />
            </div>
        </PageLayout>
    )
}


